import { BookOpen, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useReadingMode } from '@/hooks/useReadingMode';
import { useLanguage } from '@/i18n/LanguageContext';

export const ReadingModeToggle = () => {
  const { isEnabled, toggle } = useReadingMode();
  const { t } = useLanguage();

  return (
    <motion.button
      onClick={toggle}
      className={`fixed bottom-6 left-6 z-50 p-3 rounded-full border transition-all duration-300 ${
        isEnabled 
          ? 'bg-primary text-primary-foreground border-primary shadow-lg shadow-primary/20' 
          : 'bg-card/80 backdrop-blur-sm text-muted-foreground border-border/30 hover:border-border/50 hover:text-foreground'
      }`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={t('reading_mode') || 'Reading Mode (R)'}
      aria-label={isEnabled ? 'Disable reading mode' : 'Enable reading mode'}
    >
      <AnimatePresence mode="wait">
        {isEnabled ? (
          <motion.div
            key="enabled"
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: 90 }}
          >
            <X className="w-5 h-5" />
          </motion.div>
        ) : (
          <motion.div
            key="disabled"
            initial={{ opacity: 0, rotate: 90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: -90 }}
          >
            <BookOpen className="w-5 h-5" />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.button>
  );
};

export default ReadingModeToggle;
